import { useState } from "react";
import {
  useTargetCollaborationInsightsFunnel,
  useTargetCollaborationInsightsPerformance,
  useTargetCollaborationInsightsRelationships,
  useTargetCollaborationInsightsSummary,
} from "@/api/collaborations";
import type { CreatorStatusTab } from "../collaboration-table-columns";
import { CollaborationInsightsPanelView } from "./collaboration-insights-panel-view";

type Props = {
  collaborationId: string | undefined;
  showRecommendations?: boolean;
  onFilterChange?: (status: CreatorStatusTab) => void;
  onBreakdownFilterChange?: (bucket: string | null) => void;
};

export function TargetCollaborationInsightsPanel({
  collaborationId,
  showRecommendations,
  onFilterChange,
  onBreakdownFilterChange,
}: Props) {
  const [performanceMode, setPerformanceMode] = useState<"invited" | "accepted">("accepted");

  const summaryQuery = useTargetCollaborationInsightsSummary(collaborationId);
  const funnelQuery = useTargetCollaborationInsightsFunnel(collaborationId);
  const relationshipsQuery = useTargetCollaborationInsightsRelationships(collaborationId);
  const performanceQuery = useTargetCollaborationInsightsPerformance(collaborationId, performanceMode);

  return (
    <CollaborationInsightsPanelView
      summaryQuery={summaryQuery}
      funnelQuery={funnelQuery}
      relationshipsQuery={relationshipsQuery}
      performanceQuery={performanceQuery}
      recommendationsCollaborationId={collaborationId}
      collaborationType="target"
      showRecommendations={showRecommendations}
      showModeToggle
      performanceMode={performanceMode}
      onPerformanceModeChange={setPerformanceMode}
      onFilterChange={onFilterChange}
      onBreakdownFilterChange={onBreakdownFilterChange}
    />
  );
}
